import { UpdateCardLink } from '@/partials/dashboard/Cards/UpdateCard/UpdateCardLinks/UpdateCardLink';
import { UpdateCardLinksList } from '@/partials/dashboard/Cards/UpdateCard/UpdateCardLinks/UpdateCardLinksList';
import { useCardStore } from '@/stores/useCardStore';
import { motion } from 'framer-motion';
import { memo, useState } from 'react';

export const UpdateCardLinksIndex = memo(() => {
  // Use a selector to only subscribe to changes in card.links
  const links = useCardStore(state => state.card?.links);
  const [isEditing, setIsEditing] = useState<boolean>(false);
  const [selectedLinkId, setSelectedLinkId] = useState<number | null>(null);

  const handleLinkClick = (linkId: number) => {
    setSelectedLinkId(linkId);
    setIsEditing(true);
  };

  const handleCloseEdit = () => {
    setIsEditing(false);
    setSelectedLinkId(null);
  };

  // Animation variants compatibles avec les autres composants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.3,
        when: 'beforeChildren',
      },
    },
    exit: {
      opacity: 0,
      transition: {
        duration: 0.2,
      },
    },
  };

  if (isEditing && selectedLinkId !== null && links) {
    const selectedLink = links.find(link => link.id === selectedLinkId);

    if (selectedLink) {
      return (
        <motion.div
          initial="hidden"
          animate="visible"
          exit="exit"
          variants={containerVariants}
        >
          <UpdateCardLink link={selectedLink} onClose={handleCloseEdit} />
        </motion.div>
      );
    }
  }

  return (
    <motion.div
      initial="hidden"
      animate="visible"
      exit="exit"
      variants={containerVariants}
    >
      <UpdateCardLinksList onLinkClick={handleLinkClick} />
    </motion.div>
  );
});
